import { SC, CC } from "@bigspring/core-components";

export const CompanyName = SC.styled(CC.BSPBody1)`
  padding: 12px 26px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: ${({ theme }) => theme.radix.colors.gray.gray1};
`;
